import { Component, OnInit, Optional, Inject } from '@angular/core';
import { RateBoardService } from '../../services/rateboard.service';
import { Symbol } from '../models/symbol-model';
import { PershingTranslationService } from '@pershing/pershing-core';
import { RateBoardMsgProps } from '../nxi-messages/msg-properties';
@Component({
    selector: 'modern-rate-board',
    templateUrl: './modern-rate-board.component.html'
})
export class ModernRateBoardComponent implements OnInit {
    // Rate Board Config Data
    public rateBoardSymbols: Symbol;
    public rateBoardMsg = RateBoardMsgProps;
    renderError: boolean = false;
    renderRateboard: boolean = false;
    mirlFlag: boolean = false;
    msiFlag: boolean = false;
    mmflFlag: boolean = false;
    msisFlag: boolean = false;
    rateboardDisclaimerFlag: boolean = false;
    maintenanceError: boolean = false;
    themeType: string = 'conservative';

    // Save last state of currency calculator to the container incase user in mobile mode and turn device.
    lastCurrencyCaculatorState: any;

    constructor(
        private rateBoardService: RateBoardService,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
            if (appSettings.ibdConfigMap.MSI_Flag_Rateboard_Enabled) {
                this.msiFlag = appSettings.ibdConfigMap.MSI_Flag_Rateboard_Enabled;
            }
            this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');
    }
    ngOnInit() {
        this.renderRateBoard();
    }

    ngOnDestroy(): void {
        this.lastCurrencyCaculatorState = null;
    }

    updateLastCurrencyCaculatorState(data: any) {
        this.lastCurrencyCaculatorState = data;
    }

    renderRateBoard() {
        this.rateBoardService.fetchModernRateBoard()
            .subscribe(data => {
                this.rateBoardSymbols = data.response;
                this.renderRateboard = true;    
                this.mirlFlag = data.response.mirlFlagOn;
                this.mmflFlag = data.response.mmflFlagOn;
                this.msisFlag = data.response.msisFlagOn;
                this.rateboardDisclaimerFlag = data.response.rateboardDisclaimerFlagOn;          
            },
                error => {
                    return false;
                });
    }
}
